import React, { useEffect } from 'react';
import oktaSignIn from 'okta';

import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import { Navigate } from 'react-router-dom';
import { env } from 'env';

const SignInWidget = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  const applicationId = window.localStorage.getItem('applicationId');

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    sessionStorage.setItem('okta-pkce-storage', '{}');

    oktaSignIn.renderEl({ el: ref.current });

    return () => oktaSignIn.remove();
  }, []);

  useEffect(() => {
    const secureRouterReferrerPath = localStorage.getItem('secureRouterReferrerPath');

    if (!secureRouterReferrerPath) {
      localStorage.setItem('secureRouterReferrerPath', `${window.location.origin}${env.REACT_APP_BASE_URL}/`);
    }
  }, []);

  if (applicationId) {
    return <Navigate to={`../${env.REACT_APP_BASE_URL}/prequalification?applicationId=${applicationId}`} />;
  }

  return (
    <>
      <div id="sign-in-widget" ref={ref} />
    </>
  );
};

export default SignInWidget;
